function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "318593A0-2DB7-4A0F-A9C0-32288D91A8CA");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Desktop-png",
  transform: "translate(-1195.000000, -31.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "icon-fb",
  transform: "translate(1195.000000, 31.000000)"
}, React.createElement("path", {
  d: "M18.5375901,9.26879506 C18.5375901,14.3878752 14.3878752,18.5375901 9.26879506,18.5375901 C4.14971489,18.5375901 0,14.3878752 0,9.26879506 C0,4.14971489 4.14971489,0 9.26879506,0 C14.3878752,0 18.5375901,4.14971489 18.5375901,9.26879506 Z",
  id: "Path-Copy",
  fill: "#C4C4C4"
}), React.createElement("path", {
  d: "M7.63678465,5.81249065 C7.63678465,6.09621334 7.63678465,7.36344301 7.63678465,7.36344301 L6.50052794,7.36344301 L6.50052794,9.26005312 L7.63678465,9.26005312 L7.63678465,14.8955586 L9.97088189,14.8955586 L9.97088189,9.26005312 L11.5371717,9.26005312 C11.5371717,9.26005312 11.6839113,8.35046236 11.7549005,7.35630115 C11.5510261,7.35630115 9.97977993,7.35630115 9.97977993,7.35630115 C9.97977993,7.35630115 9.97977993,6.25278768 9.97977993,6.05941135 C9.97977993,5.86576183 10.2341547,5.6051038 10.4857586,5.6051038 C10.7369332,5.6051038 11.2668741,5.6051038 11.7575153,5.6051038 C11.7575153,5.34663125 11.7575153,4.45456339 11.7575153,3.63067483 C11.1024164,3.63067483 10.3571272,3.63067483 10.028407,3.63067483 C7.57898639,3.63055775 7.63678465,5.52892406 7.63678465,5.81249065 Z",
  id: "Path",
  fill: "#FFFFFF"
}))));

var SvgIconFb = function SvgIconFb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-fb.1c99ff3b.svg";
export { ForwardRef as ReactComponent };